export enum AircraftActiveType {
  Active = 'Active',
  Inactive = 'Inactive',
  All = 'All'
}
